import { socket } from "../App";

export const logoutCleanup = () => { 
  localStorage.removeItem("localUserProfile")

  socket.removeAllListeners(["redux-update-waiter"])
  socket.removeAllListeners(["registerUserToTheList"])
  socket.removeAllListeners(["registerClient"])
}